export default __webpack_public_path__ + "static/media/icon-cross.f86767c5.svg";